export const TWINS_MODULE = "TWINS_MODULE";
export const TWINS_MODULE_START = `${TWINS_MODULE}_START`;
export const TWINS_MODULE_STOP = `${TWINS_MODULE}_STOP`;

export const FPS_MODULE = "FPS_MODULE";
export const FPS_MODULE_SET_DATA = `${FPS_MODULE}_SET_DATA`;
export const FPS_MODULE_START = `${FPS_MODULE}_START`;
export const FPS_MODULE_STOP = `${FPS_MODULE}_STOP`;

export const WORKER_LOG = "WORKER_LOG";
export const WORKER_LOG_TWINS_STATUS = `${WORKER_LOG}_TWINS_STATUS`;
export const WORKER_LOG_FPS_STATUS = `${WORKER_LOG}_FPS_STATUS`;
